import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCameraSparkle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="camera-sparkle, picture, image, cam"><path d="M21.25 12.25V20.25H2.75V6.75H7.5L9.5 3.75H12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><circle cx="12" cy="13" r="3.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.4 2H18.6L17.6 4.6L15 5.6V6.4L17.6 7.4L18.6 10H19.4L20.4 7.4L23 6.4V5.6L20.4 4.6L19.4 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCameraSparkle;
